var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProjectBar'),_c('ProjectCreate'),_c('div',{attrs:{"id":"fadeLayer"}}),_c('div',{staticClass:"loading"},[_c('vue-loading',{attrs:{"id":"loading","type":"spin","color":"#333","size":{ width: '50px', height: '50px' }}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }